import session_pskey from './session/pskey'
import cookies from './cookies'
import ajax from './ajax';

/**
 * 检查登录态
 */
export default function ({ appid = '11000101', daid = '307' , s_url }) {
  return new Promise((resolve) => {
    const baseUrl = 'https://api.unipay.qq.com/v1/r/1450000186/login_check'
    const loginUrl = `https://ui.ptlogin2.qq.com/cgi-bin/login?style=9&appid=${appid}&daid=${daid}&s_url=${encodeURIComponent(s_url)}`
    if (cookies.get('p_uin').substr(1) * 1 && cookies.get('p_skey')) {
      const pskeyObj = new session_pskey({
        uin: cookies.get('p_uin').substr(1) * 1,
        pskey: cookies.get('p_skey'),
        sessiontype: `pskey_${daid}`
      })
      const params = Object.assign({
        offer_id: "1450000186",
      }, pskeyObj.getSessionParam())

      ajax({
        url: baseUrl,
        method: "POST",
        param: params,
        timeout: 30000,
        success(res) {
          if (res && res.ret === 0) {
            resolve(pskeyObj)
          } else {
            cookies.del("p_uin")
            cookies.del("p_skey")
            location.href = loginUrl
            resolve()
          }
        },
        error(err) {
          resolve(pskeyObj)
        }
      })
    } else {
      location.href = loginUrl
      resolve()
    }
  })
}
